import { useCallback, useState } from 'react'

import { useDispatch } from 'react-redux'

// UI
import { Box } from '@chakra-ui/react'
import ECCNDetailModal from '../components/ECCNDetailModal'

import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

import { useInitialTableState } from '@/components/Table/components/useInitialTableState'
import FullTable from '@/components/Table/FullTable/FullTable'
import { convertTableStateToQuery } from '@/utils/tableHelper'

import ECCNListHeader from '../components/ECCNListHeader'
import getECCNTableColumns from '../constants/eccnTableColumns'
import useECCN from '../useECCN'
import { LoadingSection } from '@/components/Elements'

const ECCNListPage = () => {
  const title = 'ECCN'

  // Modal State
  const [modalDetail, setModalDetail] = useState({
    show: false,
    isCreate: true,
  })

  //Table State
  const [storedTableState, setStoredTableState] = useInitialTableState(`table_state:eccn`, {})
  const query = convertTableStateToQuery(storedTableState)

  // Hooks
  const dispatch = useDispatch()
  const { useFetchAllECCNs, useRemoveECCN, useUpdateECCN } = useECCN()
  const { data: eccnResponse, isLoading } = useFetchAllECCNs(query)

  const removeECCN = useRemoveECCN()
  const updateECCN = useUpdateECCN()

  // Handler
  const handleAdd = () => {
    setModalDetail({
      show: true,
      isCreate: true,
      detail: {},
    })
  }

  const handleOnRowClick = (row) => {
    setModalDetail({
      show: true,
      isCreate: false,
      detail: row?.original,
    })
  }

  const handleDelete = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())

        await removeECCN.mutateAsync(id)

        // Jump back to first Page
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, removeECCN]
  )

  const handleActivate = useCallback(
    async (id) => {
      try {
        dispatch(showLoadingOverlay())
        await updateECCN.mutateAsync({ id, data: { isDeleted: false } })
        // Jump back to first Page
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoadingOverlay())
      }
    },
    [dispatch, updateECCN]
  )

  const defaultColumns = getECCNTableColumns({
    handleActivate,
    handleDelete,
  })

  if (isLoading) {
    return <LoadingSection />
  }

  return (
    <>
      <ECCNDetailModal modalDetail={modalDetail} setModalDetail={setModalDetail} />
      <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
        <ECCNListHeader title={title} handleAdd={handleAdd} query={query} />
        <Box p={5} overflow="scroll">
          <FullTable
            data={eccnResponse?.data ? eccnResponse.data : []}
            rowCount={eccnResponse?.count}
            columnDef={defaultColumns}
            state={storedTableState}
            setState={setStoredTableState}
            handleRowClick={handleOnRowClick}
          />
        </Box>
      </Box>
    </>
  )
}

export default ECCNListPage
